import React, { useState, useEffect } from 'react';
import '../styles/Payments.css';
import { getAllPayments, addPayment, updatePayment, deletePayment } from '../services/api';

function Payments() {
  const [payments, setPayments] = useState([]);
  const [newPayment, setNewPayment] = useState({ clientId: '', service: '', amount: '', status: 'Pending' });
  const [editPayment, setEditPayment] = useState(null);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const data = await getAllPayments();
        setPayments(data);
      } catch (err) {
        console.error('Failed to fetch payments:', err);
      }
    };
    fetchPayments();
  }, []);

  const handleAddPayment = async (e) => {
    e.preventDefault();
    try {
      const paymentData = { ...newPayment, date: new Date().toISOString() };
      const response = await addPayment(paymentData);
      setPayments([...payments, response]);
      setNewPayment({ clientId: '', service: '', amount: '', status: 'Pending' });
    } catch (err) {
      alert('Failed to add payment.');
    }
  };

  const handleUpdatePayment = async (e) => {
    e.preventDefault();
    try {
      await updatePayment(editPayment.id, editPayment);
      setPayments(payments.map(p => p.id === editPayment.id ? editPayment : p));
      setEditPayment(null);
    } catch (err) {
      alert('Failed to update payment.');
    }
  };

  const handleDeletePayment = async (paymentId) => {
    if (window.confirm('Are you sure you want to delete this payment?')) {
      try {
        await deletePayment(paymentId);
        setPayments(payments.filter(p => p.id !== paymentId));
      } catch (err) {
        alert('Failed to delete payment.');
      }
    }
  };

  return (
    <div className="ap-payments">
      <h2 className="ap-payments-title">Payments</h2>
      <form className="ap-add-payment-form" onSubmit={handleAddPayment}>
        <input className="ap-payment-input" name="clientId" placeholder="Client ID" value={newPayment.clientId} onChange={(e) => setNewPayment({ ...newPayment, clientId: e.target.value })} required />
        <input className="ap-payment-input" name="service" placeholder="Service" value={newPayment.service} onChange={(e) => setNewPayment({ ...newPayment, service: e.target.value })} required />
        <input className="ap-payment-input" name="amount" type="number" placeholder="Amount ($)" value={newPayment.amount} onChange={(e) => setNewPayment({ ...newPayment, amount: e.target.value })} required />
        <select className="ap-payment-select" name="status" value={newPayment.status} onChange={(e) => setNewPayment({ ...newPayment, status: e.target.value })}>
          <option value="Pending">Pending</option>
          <option value="Approved">Approved</option>
        </select>
        <button className="ap-payment-btn" type="submit">Add Payment</button>
      </form>
      <ul className="ap-payments-list">
        {payments.map((payment) => (
          <li key={payment.id} className="ap-payment-item">
            <span>{payment.clientName} - {payment.service} - ${payment.amount} - {payment.date}</span>
            <span>{payment.status}</span>
            <button className="ap-edit-btn" onClick={() => setEditPayment(payment)}>Edit</button>
            <button className="ap-delete-btn" onClick={() => handleDeletePayment(payment.id)}>Delete</button>
          </li>
        ))}
      </ul>
      {editPayment && (
        <form className="ap-edit-payment-form" onSubmit={handleUpdatePayment}>
          <h3 className="ap-edit-title">Edit Payment</h3>
          <input className="ap-payment-input" name="clientId" value={editPayment.clientId} onChange={(e) => setEditPayment({ ...editPayment, clientId: e.target.value })} required />
          <input className="ap-payment-input" name="service" value={editPayment.service} onChange={(e) => setEditPayment({ ...editPayment, service: e.target.value })} required />
          <input className="ap-payment-input" name="amount" type="number" value={editPayment.amount} onChange={(e) => setEditPayment({ ...editPayment, amount: e.target.value })} required />
          <select className="ap-payment-select" name="status" value={editPayment.status} onChange={(e) => setEditPayment({ ...editPayment, status: e.target.value })}>
            <option value="Pending">Pending</option>
            <option value="Approved">Approved</option>
          </select>
          <button className="ap-payment-btn" type="submit">Save</button>
          <button className="ap-cancel-btn" type="button" onClick={() => setEditPayment(null)}>Cancel</button>
        </form>
      )}
    </div>
  );
}

export default Payments;